<app-dialog
  [isVisible]="isAboutDialogVisible()"
  [settings]="{
    showHeader: false,
    closeOnEscape: true,
    isResizable: false,
    width: '320px',
  }"
  [emitOnHide]="true"
  (onHide)="handleDialogClose()"
  [customClass]="'about-dialog'"
  [appendTo]="''"
>
  <div dialog-body>
    <div
      class="flex flex-column p-spacing-3xl gap-spacing-3xl radius-lg background-muted-secondary-bg"
    >
      <div class="flex flex-column gap-spacing-3xl align-items-center">
        <div class="flex flex-column gap-spacing-md align-items-center">
          <img
            src="assets/images/BeaconConnect.svg"
            alt=""
            width="137.998"
            height="32"
          />
          <div class="flex flex-column gap-spacing-default align-items-center">
            <div class="title-small-bold text-primary-color">
              Beacon Connect Dispatch
            </div>
            <div class="body-small-regular text-light-color">Version 1.0.0</div>
          </div>
        </div>
        <div class="flex flex-column gap-spacing-2xl align-items-center">
          <div class="flex flex-column gap-spacing-xs align-items-center">
            <div class="body-small-regular text-caption-color">
              For any support-related questions, please reach out to us at:
            </div>
            <a
              href="mailto:cesupport@gobeacon.com"
              class="body-small-regular text-brand-color"
              >beaconconnect&#64;gobeacon.com</a
            >
            <a
              target="_blank"
              href="https://gobeacon.com/beacon-connect-dispatcher/"
              class="body-small-regular text-brand-color"
              >gobeacon.com/beacon-connect-dispatcher</a
            >
          </div>
          <div class="label-small-medium text-light-color">
            ©{{ currentYear }} Beacon Mobility. All rights reserved.
          </div>
        </div>
      </div>
      <div class="flex align-items-center justify-content-center">
        <app-button
          [label]="'Close'"
          severity="primary"
          [outlinedButton]="true"
          (onClick)="handleDialogClose()"
        />
      </div>
    </div>
  </div>
</app-dialog>
